import React from "react";
import Common_Title from "../../common/common-title/Common_Title";

const What_Is_Counselling = ({ what_counselling }) => {
  return (
    <section className="What_Is_Counselling">
      <div className="container">
        <div className="What_Is_Counselling_div">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              {/* <Common_Title title="What is Parental Counselling? " /> */}
              <Common_Title title={what_counselling?.name} />
              <div className="text_div">
                <p className="counselling_text">
                  {what_counselling.description?.replace(/<\/?[^>]+(>|$)/g, "")}
                  {/* Parental Counselling is designed to support parents in
                  understanding their child’s aptitude, personality, and
                  interests. */}
                </p>

                {/* <p className="counselling_text">
                  Our expert counsellors provide clarity on career streams,
                  course options, eligibility requirements, and long-term
                  planning to ensure informed decision-making.
                </p> */}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12">
              <div className="counselling_img_div">
                <img
                  src="/assets/images/about-us/pc-img.png"
                  alt="counselling-img"
                  className="counselling_img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default What_Is_Counselling;
